import Container from '@mui/material/Container';
import { useCurrentTenant, useErrorContext } from '@qpr/client-library';
import createNavItemsViewModel, {
  NavItem,
  NavItemsViewModelType
} from '@qpr/components/Expandable/nav-items-view-model';
import createLandingPageViewModel, {
  LandingPageViewModelType,
  Titles
} from '@qpr/landing-page/views/landing-page-view-model';
import { LandingPageProps } from '@qpr/landing-page/views/LandingPageView';
import React, { useEffect, useState } from 'react';
import LandingPageCard from '../components/LandingPage2Card';
import LandingPageGrid from '../components/LandingPage2Grid';
import LandingPageHeaders from '../components/LandingPage2Headers';
import Logo from '../components/LandingPage2Logo';

const LandingPageView = ({ navItemsViewModel }: LandingPageProps) => {
  const navItemsviewModel: NavItemsViewModelType = navItemsViewModel || createNavItemsViewModel();
  const landingPageViewModel: LandingPageViewModelType = createLandingPageViewModel();

  const { setError } = useErrorContext();

  const [headers, setHeaders] = useState<Titles>({
    title: '',
    description: ''
  });
  const [sections, setSections] = useState<NavItem[]>([]);

  const tenant = useCurrentTenant();
  const tenantSymbol = tenant.symbol;

  useEffect(() => {
    async function initData() {
      setError(null);
      const navItems = await navItemsviewModel.getNavItems();
      const titles = await landingPageViewModel.getTitles();

      if (navItems.error.message) setError(navItems.error);
      if (titles.error.message) setError(titles.error);

      if (navItems && titles) {
        setHeaders(titles.data);
        setSections(navItems.data);
      }
    }
    initData();
  }, []);

  return (
    <Container maxWidth="xl" component="main" data-testid="landingpage-main">
      <LandingPageHeaders headers={headers} logo={Logo} />
      <LandingPageGrid
        tenantSymbol={tenantSymbol}
        sections={sections}
        sizes={{
          xs: 7,
          sm: 5,
          md: 3,
          lg: 2,
          xl: 2
        }}
        card={LandingPageCard}
      />
    </Container>
  );
};

export default LandingPageView;
